import { createSignal } from "solid-js";

import { registerSW } from "virtual:pwa-register";

const [pendingUpdate, setPendingUpdate] = createSignal<() => void>();

export { pendingUpdate };

if (import.meta.env.PROD) {
  const startedAt = Date.now();

  const updateSW = registerSW({
    onNeedRefresh() {
      // within the first moments of a launch, applying the update (one quick
      // reload) is invisible — never strand people on a stale version
      if (Date.now() - startedAt < 15_000) {
        void updateSW(true);
      } else {
        setPendingUpdate(() => void updateSW(true));
      }
    },
    onOfflineReady() {
      console.info("Ready to work offline =)");
      // toast to users
    },
    onRegistered(r) {
      if (!r) return;

      // Check for updates every hour…
      setInterval(() => r.update(), 36e5);

      // …and whenever the app is brought back to the foreground
      // (mobile suspends timers, so the interval alone never fires there)
      document.addEventListener("visibilitychange", () => {
        if (!document.hidden) r.update();
      });
    },
  });
}
